import { AssistantAvailability } from '../../../../../models/assistantAvailability'
import { AssistanceStatus } from '../../../../../models/assistanceStatus'
import { Assistance } from '../../../../../models/assistance'

interface IAssistantAvailabilitySelectItem {
  availability: AssistantAvailability
  enabled?: boolean
  status?: AssistanceStatus
  flags?: AssistantAvailabilitySelectItemFlag[]
}

export enum AssistantAvailabilitySelectItemFlag {
  IsExchangeAssistance,
}

export class AssistantAvailabilitySelectItem implements IAssistantAvailabilitySelectItem {
  availability: AssistantAvailability
  enabled = true
  status: AssistanceStatus
  flags: AssistantAvailabilitySelectItemFlag[]
  assistanceBefore: Assistance
  assistanceBeforeHHMM: string
  assistanceAfter: Assistance
  assistanceAfterHHMM: string
  transitDurationMinutes: number
  // Undefined means "no configured ceiling" (see AssistantSelectComponent#onTransitDurationChange) — only set to
  // a real number when there's an actual gap-based bound (the assistant's next assistance).
  maxAllowedTransitMinutes: number | undefined
  nextAssistanceStart: Date | undefined
  hasExistingAssignment = false

  constructor(props: IAssistantAvailabilitySelectItem) {
    this.availability = props.availability
    this.enabled = props.enabled
    this.status = props.status
    this.flags = props.flags
  }
}
